export function webPath(url: string) {
    if (globalThis.window.location.origin && url) {
        return String(new URL(url, globalThis.window.location.origin))
    } else {
        return url
    }
}